import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {
  Alert,
  Box,
  Chip,
  Collapse,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';
import { useState } from 'react';
import { AddButtonIcon } from 'src/component/Buttons/AddButtonIcon';
import { DeleteButtonIcon } from 'src/component/Buttons/DeleteButtonIcon';

export const Row = ({
  row,
  t,
  handleAddSubActivity,
  handleDeleteActivity,
  handleDeleteSubActivity,
  handleAddProductionToSubActivity,
  handleDeleteProductionFromSubActivity,
  clickOnActivity,
}) => {
  const [open, setOpen] = useState(false);

  const lenSubActivity = row?.sub_activities?.length || row?.subActivityList?.length || 0;

  return (
    <>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => {
              clickOnActivity(row?.id);
              setOpen(!open);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell style={{ textTransform: 'capitalize' }} component="th" scope="row">
          <span
            style={{
              color: '#334155',
              fontWeight: '600',
              fontSize: '1rem',
              letterSpacing: '0.05em',
            }}
          >
            {row.name}
          </span>
        </TableCell>
        <TableCell align="right">
          <AddButtonIcon title={t('add_sub_activity')} onClick={() => handleAddSubActivity(row.id)} />
          <DeleteButtonIcon title={t('delete_activity')} onClick={() => handleDeleteActivity(row.id)} />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {lenSubActivity === 0 && (
              <Box sx={{ marginY: 1 }}>
                <Alert severity="warning">{t('no_sub_activity_added')}</Alert>
              </Box>
            )}
            <Box sx={{ marginY: 1 }}>
              <Stack direction="row" spacing={1}>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }}>
                    <TableBody>
                      {(row?.sub_activities || row?.subActivityList || [])
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map((sub, index) => (
                          <SubRow
                            handleDeleteProductionFromSubActivity={handleDeleteProductionFromSubActivity}
                            handleAddProductionToSubActivity={() => handleAddProductionToSubActivity(row.id, sub.id)}
                            onDelete={() => handleDeleteSubActivity(row.id, sub.id)}
                            prodctions={sub?.productions || sub?.productionList}
                            key={index}
                            name={sub.name}
                            t={t}
                            subId={sub.id}
                          />
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Stack>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export const SubRow = ({
  name,
  t,
  prodctions = [],
  onDelete,
  handleAddProductionToSubActivity,
  subId,
  handleDeleteProductionFromSubActivity,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow style={{ backgroundColor: '#f8fafc' }} sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell style={{ textTransform: 'capitalize' }} component="th" scope="row">
          <span style={{ color: '#475569', fontWeight: '500', fontSize: '0.875rem' }}>{name}</span>
        </TableCell>
        <TableCell align="right">
          <AddButtonIcon title={t('add_production')} onClick={handleAddProductionToSubActivity} />
          <DeleteButtonIcon title={t('delete_sub_activity')} onClick={onDelete} />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {prodctions.length === 0 && (
              <Box sx={{ marginY: 1 }}>
                <Alert severity="warning">{t('no_production_added')}</Alert>
              </Box>
            )}
            <Box sx={{ marginY: 1 }}>
              <Stack direction="row" spacing={1} flexWrap="wrap">
                {prodctions
                  .sort((a, b) => a.name.localeCompare(b.name)) 
                  .map((production, index) => (
                    <Chip
                      color="success"
                      onDelete={() => handleDeleteProductionFromSubActivity(production.id, subId)}
                      key={index}
                      label={production.name}
                      sx={{
                        marginRight: 1,
                        marginBottom: 1,
                        ...(index !== 0 && { marginTop: 1 }),
                      }}
                    />
                  ))}
              </Stack>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};
